import { Cascader, Form, Input, Select } from "antd";
import "./Info_Product.scss";
import { useEffect, useState } from "react";
import { getCondition } from "../../services/headersProducts/headersProducts";

function Info_Products({ onChangeInfo }) {
  const options = [
    {
      value: "Áo nữ",
      label: "Nữ",

      children: [
        {
          value: "ao",
          label: "Áo",
        },
        {
          label: "Giày",
          value: "giay",
        },
        {
          label: "Quần jeans",
          value: "quan-jeans",
        },
        {
          label: "Túi xách & ví",
          value: "tui-xách-&-vi",
        },
        {
          label: "Áo len",
          value: "ao-len",
        },
        {
          label: "Kính râm",
          value: "kinh-ram",
        },
        {
          label: "Váy",
          value: "vay",
        },
        {
          label: "Mũ",
          value: "mu",
        },
        {
          label: "Những vật dụng thiết yếu",
          value: "vat-dung-thiet-yeu",
        },
        {
          label: "Denim",
          value: "Denim",
        },
        {
          label: "Giày thể thao",
          value: "giay-the-thao",
        },
        {
          label: "Trang phục công sở",
          value: "trang-phuc-cong-so",
        },
        {
          label: "Đồ tập thể dục",
          value: "do-tap-the-duc",
        },
        {
          label: "Tối giản",
          value: "toi-gian",
        },
        {
          label: "Quyến rũ",
          value: "quyen-ru",
        },
        {
          label: "Y2k",
          value: "y2k",
        },
        {
          label: "Phong cách Boho",
          value: "phong-cach-boho",
        },
      ],
    },
    {
      value: "Man",
      label: "Nam",

      children: [
        {
          label: "Áo thun",
          value: "ao-thun",
        },
        {
          label: "Giày",
          value: "giay",
        },
        {
          label: "Áo sơ mi",
          value: "ao-so-mo",
        },
        {
          label: "Túi xách & ví",
          value: "tui-xách-&-vi",
        },
        {
          label: "Áo hoodie",
          value: "ao-hoodie",
        },
        {
          label: "Mũ",
          value: "mu",
        },
        {
          label: "Quần jeans",
          value: "quan-jeans",
        },
        {
          label: "Phụ kiện",
          value: "phu-kien",
        },
        {
          label: "Những vật dụng thiết yếu",
          value: "vat-dung-thiet-yeu",
        },
        {
          label: "Denim",
          value: "Denim",
        },
        {
          label: "Giày thể thao",
          value: "giay-the-thao",
        },
        {
          label: "Trang phục công sở",
          value: "trang-phuc-cong-so",
        },
        {
          label: "Đồ tập thể dục",
          value: "do-tap-the-duc",
        },
        {
          label: "Gorpcore",
          value: "gorpcore",
        },
        {
          label: "Đường phố",
          value: "duong-pho",
        },
        {
          label: "Tối giản",
          value: "toi-gian",
        },
        {
          label: "Lao động",
          value: "lao-dong",
        },
      ],
    },
    {
      value: "Kids",
      label: "Trẻ em",

      children: [
        {
          label: "Áo",
          value: "ao",
        },
        {
          label: "Quần",
          value: "quan",
        },
        {
          label: "Váy",
          value: "vay",
        },
        {
          label: "Áo khoác",
          value: "ao-khoac",
        },
        {
          label: "Giày",
          value: "giay",
        },
        {
          label: "Đồ bộ",
          value: "đồ bộ",
        },
        {
          label: "Trai",
          value: "trai",
        },
        {
          label: "Gái",
          value: "gai",
        },
        {
          label: "Unisex",
          value: "unisex",
        },
        {
          label: "(0-12 tháng)",
          value: "0-12",
        },
        {
          label: "(1-3) tuổi",
          value: "1-3",
        },
        {
          label: "(4-12) tuổi",
          value: "4-12",
        },
        {
          label: "(13-16) tuổi",
          value: "13-16",
        },
      ],
    },
  ];

  const options2 = [
    {
      value: "size-chu",
      label: "Size chữ",
      children: [
        { value: "S", label: "S" },
        { value: "M", label: "M" },
        { value: "L", label: "L" },
        { value: "XL", label: "XL" },
        { value: "2XL", label: "2XL" },
        { value: "3XL", label: "3XL" },
      ],
    },

    {
      value: "size-so",
      label: "Size số",
      children: [
        { value: "36", label: "36" },
        { value: "37", label: "37" },
        { value: "38", label: "38" },
        { value: "39", label: "39" },
        { value: "40", label: "40" },
        { value: "41", label: "41" },
        { value: "42", label: "42" },
        { value: "43", label: "43" },
        { value: "44", label: "44" },
        { value: "45", label: "45" },
      ],
    },

    {
      value: "",
      label: "Không có",
    },
  ];

  const [condition, setCondition] = useState([]);

  // giữ nguyên như code cũ
  const [category, setCategory] = useState([]);
  const [brand, setBrand] = useState("");
  const [title, setTitle] = useState("");
  const [productCondition, setProductCondition] = useState("");
  const [color, setColor] = useState("");
  const [size, setSize] = useState([]);
  const [price, setPrice] = useState("");
  const [sales, setSales] = useState("");

  useEffect(() => {
    const fetchApi = async () => {
      let contentCondition = await getCondition();
      contentCondition = contentCondition.map((item) => ({
        value: item.key,
        label: item.name,
      }));
      setCondition(contentCondition);
    };
    fetchApi();
  }, []);

  useEffect(() => {
    onChangeInfo({
      category,
      brand,
      title,
      productCondition,
      color,
      size,
      price,
      sales,
    });
  }, [category, brand, title, productCondition, color, size, price, sales]);

  return (
    <div className="info-products">
      <Form layout="vertical">
        {/* CATEGORY */}
        <div className="info-products-object">
          <div className="info-object">Đối tượng</div>
          <Form.Item
            rules={[{ required: true, message: "Vui lòng chọn danh mục" }]}
            className="clean-form-item"
          >
            <Cascader
              className="cascader-object"
              variant="borderless"
              options={options}
              placeholder="Vui lòng chọn"
              onChange={(val) => setCategory(val)}
            />
          </Form.Item>
        </div>

        {/* TITLE */}
        <div className="info-products-title">
          <div className="info-title">Tên sản phẩm</div>
          <Form.Item
            rules={[{ required: true, message: "Vui lòng nhập tên sản phẩm" }]}
            className="clean-form-item"
          >
            <Input
              maxLength={20}
              className="input-title"
              onChange={(e) => setTitle(e.target.value)}
            />
          </Form.Item>
        </div>

        {/* BRAND */}
        <div className="info-products-brands">
          <div className="info-brands">Thương hiệu</div>
          <Form.Item
            rules={[{ required: true, message: "Vui lòng nhập thương hiệu" }]}
            className="clean-form-item"
          >
            <Input
              maxLength={20}
              className="input-brands"
              onChange={(e) => setBrand(e.target.value)}
            />
          </Form.Item>
        </div>

        {/* CONDITION */}
        <div className="info-products-condition">
          <div className="info-condition">Điều kiện</div>
          <Form.Item
            rules={[{ required: true, message: "Vui lòng chọn tình trạng" }]}
            className="clean-form-item"
          >
            <Select
              allowClear
              variant="borderless"
              options={condition}
              placeholder="Tình trạng"
              className="select-condition"
              onChange={(val) => setProductCondition(val)}
            />
          </Form.Item>
        </div>

        {/* COLOR */}
        <div className="info-products-color">
          <div className="info-color">Màu sắc</div>
          <Form.Item
            rules={[{ required: true, message: "Vui lòng chọn màu sắc" }]}
            className="clean-form-item"
          >
            <Select
              allowClear
              className="select-color"
              placeholder="Màu sắc"
              variant="borderless"
              options={[
                { value: "Trắng", label: "Trắng" },
                { value: "Kem", label: "Kem" },
                { value: "Xám", label: "Xám" },
                { value: "Xanh lá", label: "Xanh lá" },
                { value: "Đen", label: "Đen" },
              ]}
              onChange={(val) => setColor(val)}
            />
          </Form.Item>
        </div>

        {/* SIZE */}
        <div className="info-products-size">
          <div className="info-color">Size</div>
          <Form.Item
            rules={[{ required: true, message: "Vui lòng chọn size" }]}
            className="clean-form-item"
          >
            <Cascader
              variant="borderless"
              options={options2}
              placeholder="Please select"
              className="cascader-size"
              onChange={(val) => setSize(val)}
            />
          </Form.Item>
        </div>

        {/* PRICE */}
        <div className="info-products-price">
          <div className="info-brands">Giá</div>
          <Form.Item
            rules={[{ required: true, message: "Vui lòng nhập giá" }]}
            className="clean-form-item"
          >
            <Input type="number" onChange={(e) => setPrice(e.target.value)} />
          </Form.Item>
        </div>

        {/* SALES */}
        <div className="info-products-sales">
          <div className="info-brands">Giảm giá</div>
          <Form.Item
            rules={[
              {
                required: true,
                message: "Vui lòng nhập giảm giá (0 nếu không)",
              },
            ]}
            className="clean-form-item"
          >
            <Input type="number" onChange={(e) => setSales(e.target.value)} />
          </Form.Item>
        </div>
      </Form>
    </div>
  );
}

export default Info_Products;
